var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 490,
    viewBox: "0 0 859 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27.4038C0 27.4038 6.58571 22.4645 8.47605 14.4153C10.3664 6.36613 17.379 1 17.379 1",
    stroke: "url(#paint0_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.3562C0 49.3562 22.5622 42.4046 28.5381 24.9037C34.2701 7.8906 57.442 1 57.442 1",
    stroke: "url(#paint1_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 71.3085C0 71.3085 38.5386 62.3447 48.5391 35.453C58.1738 9.53703 97.5051 1 97.5051 1",
    stroke: "url(#paint2_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 93.3219C0 93.3219 54.4541 82.2847 68.6011 46.0023C82.0774 11.1225 137.507 1 137.507 1",
    stroke: "url(#paint3_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 115.274C0 115.274 70.4305 102.225 88.6022 56.5517C105.981 12.7689 177.57 1 177.57 1",
    stroke: "url(#paint4_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 137.227C0 137.227 86.4069 122.165 108.664 67.04C129.885 14.4153 217.633 1 217.633 1",
    stroke: "url(#paint5_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 159.24C0 159.24 102.322 142.105 128.665 77.6503C153.789 16.0008 257.696 1 257.696 1",
    stroke: "url(#paint6_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 181.192C0 181.192 118.299 162.045 148.727 88.1387C177.692 17.6472 297.759 1 297.759 1",
    stroke: "url(#paint7_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 203.145C0 203.145 134.275 181.985 168.789 98.688C201.596 19.2936 337.761 1 337.761 1",
    stroke: "url(#paint8_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 225.158C0 225.158 150.191 201.986 188.79 109.237C225.561 20.8791 377.825 1 377.825 1",
    stroke: "url(#paint9_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 247.11C0 247.11 166.167 221.865 208.852 119.787C249.464 22.5255 417.888 1 417.888 1",
    stroke: "url(#paint10_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 269.063C0 269.063 182.144 241.805 228.853 130.275C273.368 24.1719 457.951 1 457.951 1",
    stroke: "url(#paint11_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 291.076C0 291.076 198.059 261.806 248.915 140.885C297.272 25.7574 497.953 1 497.953 1",
    stroke: "url(#paint12_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 313.028C0 313.028 214.036 281.746 268.916 151.435C321.175 27.4038 538.016 1 538.016 1",
    stroke: "url(#paint13_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 335.042C0 335.042 230.012 301.686 288.978 161.984C345.079 29.0502 578.079 1 578.079 1",
    stroke: "url(#paint14_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 356.994C0 356.994 245.927 321.626 308.98 172.533C368.983 30.6357 618.142 1 618.142 1",
    stroke: "url(#paint15_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 378.947C0 378.947 261.904 341.567 329.042 183.022C392.886 32.2821 658.205 1 658.205 1",
    stroke: "url(#paint16_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 400.96C0 400.96 277.88 361.507 349.104 193.632C416.79 33.9285 698.207 1 698.207 1",
    stroke: "url(#paint17_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 422.912C0 422.912 293.796 381.447 369.105 204.12C440.694 35.514 738.27 1 738.27 1",
    stroke: "url(#paint18_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 444.865C0 444.865 309.772 401.387 389.167 214.67C464.597 37.1604 778.333 1 778.333 1",
    stroke: "url(#paint19_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 466.878C0 466.878 325.749 421.388 409.168 225.219C488.501 38.8068 818.396 1 818.396 1",
    stroke: "url(#paint20_linear_2073_2299)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 488.83C0 488.83 341.664 441.267 429.23 235.768C512.405 40.3923 858.398 1 858.398 1",
    stroke: "url(#paint21_linear_2073_2299)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2073_2299",
    x1: 8.68948,
    y1: 1,
    x2: 8.68948,
    y2: 27.4038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2073_2299",
    x1: 28.721,
    y1: 1,
    x2: 28.721,
    y2: 49.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2073_2299",
    x1: 48.7525,
    y1: 1,
    x2: 48.7525,
    y2: 71.3085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2073_2299",
    x1: 68.7536,
    y1: 1,
    x2: 68.7536,
    y2: 93.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2073_2299",
    x1: 88.7851,
    y1: 1,
    x2: 88.7851,
    y2: 115.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2073_2299",
    x1: 108.817,
    y1: 1,
    x2: 108.817,
    y2: 137.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2073_2299",
    x1: 128.848,
    y1: 1,
    x2: 128.848,
    y2: 159.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2073_2299",
    x1: 148.88,
    y1: 1,
    x2: 148.88,
    y2: 181.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2073_2299",
    x1: 168.881,
    y1: 1,
    x2: 168.881,
    y2: 203.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2073_2299",
    x1: 188.912,
    y1: 1,
    x2: 188.912,
    y2: 225.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2073_2299",
    x1: 208.944,
    y1: 1,
    x2: 208.944,
    y2: 247.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2073_2299",
    x1: 228.975,
    y1: 1,
    x2: 228.975,
    y2: 269.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2073_2299",
    x1: 248.976,
    y1: 1,
    x2: 248.976,
    y2: 291.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2073_2299",
    x1: 269.008,
    y1: 1,
    x2: 269.008,
    y2: 313.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2073_2299",
    x1: 289.039,
    y1: 1,
    x2: 289.039,
    y2: 335.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2073_2299",
    x1: 309.071,
    y1: 1,
    x2: 309.071,
    y2: 356.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2073_2299",
    x1: 329.103,
    y1: 1,
    x2: 329.103,
    y2: 378.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2073_2299",
    x1: 349.104,
    y1: 1,
    x2: 349.104,
    y2: 400.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2073_2299",
    x1: 369.135,
    y1: 1,
    x2: 369.135,
    y2: 422.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2073_2299",
    x1: 389.167,
    y1: 1,
    x2: 389.167,
    y2: 444.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2073_2299",
    x1: 409.198,
    y1: 1,
    x2: 409.198,
    y2: 466.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2073_2299",
    x1: 429.199,
    y1: 1,
    x2: 429.199,
    y2: 488.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10);
export default __webpack_public_path__ + "static/media/Group (10).ee2db7cda786145f0dd69a50e5f9df1c.svg";
export { ForwardRef as ReactComponent };